<div class="modal-container">
  <div class="modal-content">
    <div class="modal-header">
      <h1 class="my-account-h1--dark">{{title}}</h1>
    </div>
    <div class="modal-body">
      <div class="modal-activity" *ngFor="let block of blocks">
        <div *ngFor="let question of block.questions">
          <div class="my-account-choices-container"
            *ngIf="question.questionType === enumQuestionType.MultiChoiceSingleAnswer">
            <h2 class="my-account-h2--light" id="question_{{question.questionID}}">{{question.questionText}}</h2>
            <div *ngFor="let choice of question.choices">
              <div class="my-account-survey-choice">
                <input *ngIf="question.questionType === enumQuestionType.MultiChoiceSingleAnswer"
                  class="my-account-survey-checkbox" id="question_{{question.questionID}}-check_{{choice.id}}"
                  type="radio" name="choice" (change)="onChoiceChange($event, choice, question.questionID)">
                <label for="question_{{question.questionID}}-check_{{choice.id}}"></label>
                <span class="my-account-primary-paragraph" id="choice{{choice.id}}">{{choice.label}}</span>
                <div class="my-account-survey-dep-question" *ngIf="choice['dep']">
                  <p class="my-account-tertiary-paragraph my-account-choice-text" id="depQuestion{{choice.id}}">
                    {{choice['dep'].questionText}}</p>
                  <textarea *ngIf="choice['dep'].questionType === enumQuestionType.TextEntryMultiLine"
                    id="textarea{{choice.id}}" (change)="userResponse = $event.target.value" class="choice-textarea"
                    rows="4" cols="50"></textarea>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="my-account-choices-container"
            *ngIf="(question.questionType === enumQuestionType.TextEntryMultiLine || question.questionType === enumQuestionType.TextEntrySingleLine) && !question.displayLogic">
            <h2 class="my-account-h2--light" id="question_{{question.questionID}}">{{question.questionText}}</h2>
            <textarea id="textarea{{question.questionID}}" (change)="userResponse = $event.target.value"
              class="choice-textarea" rows="4" cols="50"></textarea>
          </div>-->
        </div>
      </div>
      <div class="modal-buttons">
        <button type="button" (click)="dismiss()" [disabled]="btnDisabled" [attr.disabled]="btnDisabled ? true: null"
          class="my-account-primary-button">
          {{ 'privacy.goodByeSurveyButton' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>